import { rokidBaseUrl } from "@rokid/host";
import {copyResourceTransTemplate} from './template.d';

import {
  request,
  type IRequest,
  type IResult,
  type pageData,
} from "@rokid/utils";


//资源添加为模板
export const addTemplate: IRequest<copyResourceTransTemplate,Boolean> = (param) => {
  return request({
    url: `${rokidBaseUrl}/api/marketplace/product/addTemplate`,
    method: "post",
     data: param
  }).then((res) => res.data);
};

//删除模板
export const deleteTemplate: IRequest<string,Boolean> = (templateId) => {
  return request({
    url: `${rokidBaseUrl}/api/marketplace/product/deleteTemplate`,
    method: "post",
    data: {templateId:Number(templateId) }
  }).then((res) => res.data);
};